import React from "react";
import { LogOut } from "lucide-react";

export default function Navbar({ user, onLogout, currentPage, onNavigate, bloqueado = false }) {
  const menuItems = [
    { id: "dashboard", label: "Dashboard" },
    { id: "mailing",   label: "Gerar Lista de Empresas" },
  ];

  const groups = user?.groups || [];
  const canSeeAdmin = user?.is_superuser || groups.includes("ADM") || groups.includes("SUPORTE");
  // Cliente (login pelo SSO da Área do Cliente) não tem tela de Perfil, mesmo com grupos herdados.
  const isInternal = user?.sso === true ? false : Boolean(canSeeAdmin);

  if (isInternal) {
    menuItems.push({ id: "profile", label: "Perfil" });
  }

  if (canSeeAdmin) {
    menuItems.push({ id: "admin", label: "Admin" });
  }

  return (
    <header className="top-navbar">
      {/* ESQUERDA: logo + links */}
      <div className="top-navbar-left">
        <div className="brand-circle">
          <img
            src={`${process.env.PUBLIC_URL}/Simbolo.png`}
            alt="DadosPJ"
            className="brand-logo"
          />
        </div>
        <div>
          <div className="brand-text-main">DadosPJ</div>
          <div className="brand-text-sub">Copiloto B2B</div>
        </div>

        {/* NAV LINKS */}
        <nav className="top-nav-links">
          {menuItems.map((item) => (
            <button
              key={item.id}
              type="button"
              className={`top-nav-link ${bloqueado ? "top-nav-link--bloqueado" : currentPage === item.id ? "top-nav-link--active" : ""}`}
              disabled={bloqueado}
              data-guia={"menu:/" + item.id}
              onClick={() => onNavigate(item.id)}
            >
              {bloqueado && <span aria-hidden="true">🔒 </span>}
              {item.label}
            </button>
          ))}
        </nav>
      </div>

      {/* DIREITA: usuário + sair */}
      <div className="top-navbar-right">
        <div className="user-chip">
          <div className="user-avatar">
            {user?.email?.[0]?.toUpperCase() || "U"}
          </div>
          <div className="user-info">
            <span className="user-name">
              {user?.nome || user?.name || [user?.first_name, user?.last_name].filter(Boolean).join(" ") || user?.email || user?.username || "Usuário"}
            </span>
            <span className="user-email">{user?.email}</span>
          </div>
        </div>

        <button type="button" className="btn-ghost" onClick={onLogout}>
          <LogOut size={16} />
          Sair
        </button>
      </div>
    </header>
  );
}
